import { gql } from "@apollo/client";

export const createVersionForApp = gql`
    mutation CreateAppVersion($appId: String!, $sourceVersion: Int!, $appVersionName: String!) {
        createAppVersion(input: { appId: $appId, sourceVersion: $sourceVersion, appVersionName: $appVersionName }) {
            appVersion {
                appId
                version
                versionName
                features {
                    enabled
                    featureScopeName
                }
            }
        }
    }
`;
